(function () {
  var PAGE_SIZE = 5;

  function initGallery(gallery) {
    var thumbnailList = gallery.querySelector('.thumbnail-list');
    if (!thumbnailList) return;

    // Detach from Dawn's own slider-component behaviour entirely - it
    // manages elements carrying this class (that's what permanently
    // disabled the original thumbnail prev/next buttons, since it bases
    // that on horizontal scroll capacity this column never has in the
    // same way).
    thumbnailList.classList.remove('slider', 'slider--mobile', 'slider--tablet-up');

    var items = Array.from(thumbnailList.querySelectorAll('.thumbnail-list__item')).filter(function (item) {
      return item.style.display !== 'none' && getComputedStyle(item).display !== 'none';
    });
    var thumbnailButtons = items.map(function (item) {
      return item.querySelector('.thumbnail');
    }).filter(Boolean);

    var start = 0;
    var lastPageStart = Math.max(0, items.length - PAGE_SIZE);
    var pagingNeeded = items.length > PAGE_SIZE;

    function renderPage() {
      if (!pagingNeeded) return;
      items.forEach(function (item, index) {
        if (index >= start && index < start + PAGE_SIZE) {
          item.removeAttribute('data-lushe-thumb-hidden');
        } else {
          item.setAttribute('data-lushe-thumb-hidden', '');
        }
      });
    }

    // Brings a given real-item index onto the visible page if it isn't
    // already, without changing which page it lands on any more than
    // necessary.
    function ensureVisible(index) {
      if (!pagingNeeded || (index >= start && index < start + PAGE_SIZE)) return;
      start = Math.min(lastPageStart, Math.max(0, index - Math.floor(PAGE_SIZE / 2)));
      renderPage();
    }

    // Shared by both the thumbnail column's own arrows and the main
    // image's overlay arrows: select the next/previous real image
    // (looping head-to-tail) and make sure its thumbnail is paged into
    // view - so either control drives both the main image and the
    // thumbnail strip together.
    function selectByDelta(delta) {
      if (thumbnailButtons.length < 2) return;
      var currentIndex = thumbnailButtons.findIndex(function (button) {
        return button.getAttribute('aria-current') === 'true';
      });
      if (currentIndex === -1) currentIndex = 0;
      var nextIndex = (currentIndex + delta + thumbnailButtons.length) % thumbnailButtons.length;
      thumbnailButtons[nextIndex].click();
      ensureVisible(nextIndex);
    }

    renderPage();

    var thumbSlider = thumbnailList.closest('.thumbnail-slider');
    var thumbPrev = thumbSlider ? thumbSlider.querySelector('[data-lushe-thumb-prev]') : null;
    var thumbNext = thumbSlider ? thumbSlider.querySelector('[data-lushe-thumb-next]') : null;
    if (thumbPrev) {
      thumbPrev.addEventListener('click', function (event) {
        event.preventDefault();
        selectByDelta(-1);
      });
    }
    if (thumbNext) {
      thumbNext.addEventListener('click', function (event) {
        event.preventDefault();
        selectByDelta(1);
      });
    }

    var viewer = gallery.querySelector('slider-component:not(.thumbnail-slider)');
    var mainPrev = viewer ? viewer.querySelector('[data-lushe-main-prev]') : null;
    var mainNext = viewer ? viewer.querySelector('[data-lushe-main-next]') : null;
    if (mainPrev) {
      mainPrev.addEventListener('click', function (event) {
        event.preventDefault();
        selectByDelta(-1);
      });
    }
    if (mainNext) {
      mainNext.addEventListener('click', function (event) {
        event.preventDefault();
        selectByDelta(1);
      });
    }
  }

  function init() {
    document.querySelectorAll('.product--thumbnail media-gallery').forEach(initGallery);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
